import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SelectionCriterionDto } from "../../../../../../autogen/bff-api";
import { SelectionCriteriaList } from "../summary/SelectionCriteriaList";
import { SELECTION_CRITERION_TYPE_OPTIONS } from "../../utils/publicProcurementOptions";
import { EspdGuidingMessage } from "./EspdGuidingMessage";
import { EspdPreviewPart } from "./EspdPreviewPart";

interface Props {
  criteria: SelectionCriterionDto[];
}

const TYPE_ORDER: Record<string, number> = Object.fromEntries(
  SELECTION_CRITERION_TYPE_OPTIONS.map((option, index) => [option.value, index]),
);

export const EspdPreviewDelIV = ({ criteria }: Props) => {
  const { t } = useTranslation();

  const sortedByType = [...criteria].sort(
    (a, b) => (TYPE_ORDER[a.type] ?? 999) - (TYPE_ORDER[b.type] ?? 999),
  );

  return (
    <EspdPreviewPart eyebrow={t("Part IV")} title={t("Selection criteria")} owner="buyer">
      <EspdGuidingMessage>
        {t("The supplier will be asked to confirm that they meet all of the criteria below:")}
      </EspdGuidingMessage>

      {sortedByType.length === 0 ? (
        <Text fontSize="sm" color="smMuted" fontStyle="italic">
          {t("No selection criteria are configured.")}
        </Text>
      ) : (
        <SelectionCriteriaList criteria={sortedByType} />
      )}

      <Text fontSize="sm" mt="5">
        {t("The supplier confirms all criteria with a single declaration. Where documentation is required, the supplier uploads it and may add an optional justification.")}
      </Text>
    </EspdPreviewPart>
  );
};
